
import { Routes } from '@angular/router';

import { AppLayout } from './layout/component/app.layout';
import { Notfound } from './pages/notfound/notfound';
import { AuthGuard } from './shared/guards/auth.guard';
import { AppRoutes } from './shared/models/routes.model';

export const appRoutes: Routes = [
  {
    path: '',
    component: AppLayout,
    canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: AppRoutes.DASHBOARD, pathMatch: 'full' },
      {
        path: AppRoutes.DASHBOARD,
        loadChildren: () => import('./shared/routes/dashboard.routes'),
      },
      {
        path: 'clienti',
        loadChildren: () => import('./shared/routes/customers.routes'),
      },
      {
        path: 'operatori',
        loadChildren: () => import('./shared/routes/operators.routes'),
      },
      {
        path: 'ticket',
        loadChildren: () => import('./shared/routes/tickets.routes'),
      },
      {
        path: 'profilo',
        loadChildren: () => import('./shared/routes/profile.routes'),
      },
    ],
  },
  { path: AppRoutes.NOT_FOUND, component: Notfound },
  {
    path: AppRoutes.AUTH,
    loadChildren: () => import('./pages/auth/auth.routes'),
  },
  { path: '**', redirectTo: AppRoutes.NOT_FOUND },
];
